module.exports = __webpack_public_path__ + "img/1.16c77228.png";